<template>
  <div>
    <Title
      :title="title"
      :count="countEdited"
      :total="total" />
    <div class="flex flex-align-center">
      <SearchInput
        v-if="countEdited"
        ref="searchTagInput"
        v-model="searchQuery"
        class="greedy"
        :placeholder="searchPlaceholder"
        full-width
        flat
        no-hover
        :icon-size="12" />
      <!-- <div
        v-if="!readOnly"
        class="ml-2 btn-highlight show-hand flex flex-align-center"
        @click="removeAll()" >
        <p class="lighter">Delete all</p>
        <SBIcon
          style="margin-right: 6px;"
          :icon="SBIconList.TRASH"
          :color="SBColors.blackUltralight"
          :hover-icon-color="SBColors.blackPrimary"
          :hover-size="24"
          :size="14"
          pointer />
      </div> -->
    </div>

    <template v-if="countEdited">
      <DefaultList
        v-if="remoteDataKey === 'default'" />
      <UrlList
        v-else-if="remoteDataKey === 'url'"
        :items="listData.filter(item => !itemsToRemove.includes(item.uid)).filter(item => item.url.includes(searchQuery))"
        :read-only="readOnly"
        :remove-callback="remove" />
    </template>
    <div
      v-else
      style="margin-top: 7px;"
      class="flex flex-align-center" >
      <span
        style="font-size: 12px !important;"
        class="emoji-fix mr-2" >😐</span>
      <p style="font-size: 14px;" >{{ noScrapedDataMessage }}</p>
    </div>

    <div
      v-if="searchQuery && !fetchingData && !listData.filter(item => !itemsToRemove.includes(item.uid)).filter(item => item.url.includes(searchQuery)).length"
      class="flex flex-align-center mt-2"
      style="color: #54626c; font-size: 14px; line-height: 1.2;" >
      <span class="emoji-fix no-shrink mr-2">😐</span>
      <p>We could't find anything for <span style="font-weight: 500 !important;">{{ searchQuery }}</span></p>
    </div>

    <!--
    Load more data is shown if there is:
      - no links data which means the first page was not being requested yet so when this comes into view it will trigger
      - next data page present
     -->
    <LoadMoreData
      v-if="!linksData || (linksData && linksData.next)"
      class="mt-3"
      :loading="false"
      @loadMore="fetchData" />
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SearchInput from '@/components/business/widgets/SearchInput';
import LoadMoreData from '@/components/common/widgets/LoadMoreData';
import api from '@/helpers/api';
import Title from '@/components/formElements/Title.form';
import DefaultList from './widgets/DefaultList';
import UrlList from './widgets/UrlList';

export default {
  name: 'RemoteData',
  components: {
    LoadMoreData,
    SBIcon,
    SearchInput,
    DefaultList,
    UrlList,
    Title,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    endpoint: {
      type: String,
      required: true,
    },
    searchPlaceholder: {
      type: String,
      default: 'Search...',
    },
    searchTag: {
      type: String,
      default: 'search',
    },
    title: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    remoteDataKey: {
      type: String,
      default: 'default',
    },
    count: {
      type: Number,
      default: null,
    },
    total: {
      type: Number,
      default: null,
    },
    noScrapedDataMessage: {
      type: String,
      default: 'There are no remote data.',
    },
  },
  data() {
    return {
      SBColors,
      SBIconList,
      listData: [],
      searchQuery: '',
      metaData: null,
      linksData: null,
      fetchingData: false,
      noMoreData: false,
      itemsToRemove: [],
    };
  },
  computed: {
    countEdited() {
      return this.count - this.itemsToRemove.length;
    },
    hideMe() {
      return !(
        this.searchQuery ||
        this.fetchingData ||
        (
          this.schema &&
          this.schema.endpoint &&
          (
            !this.metaData ||
            (
              this.metaData && this.listData.length
            )
          )
        )
      );
    },
  },
  watch: {
    searchQuery() {
      this.fetchData(true);
    },
  },
  mounted() {
    if (this.value && this.value.length) {
      this.itemsToRemove = this.value.map(item => item.uid);
    }
  },
  methods: {
    fetchData(searchDataFirstPage = false) {
      if (this.fetchingData) return;

      this.fetchingData = true;
      let currentEndpoint = this.endpoint;
      const params = {
        noPrefix: true,
      };
      if (!searchDataFirstPage && this.linksData && this.linksData.next) {
        currentEndpoint = this.linksData.next;
      } else if (this.noMoreData) {
        this.fetchingData = false;
        return;
      } else {
        params.page = 1;
        params.limit = 255;
        if (this.searchQuery) {
          params[this.searchTag] = this.searchQuery;
        }
      }
      api('GET', currentEndpoint, params, null, 'w')
        .then((response) => {
          this.metaData = response.data.meta;
          this.linksData = response.data.links;
          if (searchDataFirstPage) {
            this.listData = response.data.data;
          } else {
            this.listData = [...this.listData, ...response.data.data];
          }

          if (!this.searchQuery && !response.data.links.next) {
            this.noMoreData = true;
          }
        })
        .finally(() => {
          this.fetchingData = false;
        });
    },
    removeAll() {},
    remove(e, item) {
      e.preventDefault();
      e.stopPropagation();
      const index = this.listData.findIndex(i => this.$lodash.isEqual(i, item));
      this.itemsToRemove.push(this.listData[index].uid);
      this.listData.splice(index, 1);
      this.emitData();
    },
    emitData() {
      this.$emit('status', {
        valid: true,
      });
      this.$emit('input', this.itemsToRemove.map(item => (
        {
          uid: item,
          action: 'delete',
        }
      )));
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-highlight {
  &:hover {
    p {
      color: $blackPrimary;
    }
    ::v-deep .sb-icon .icon.mask {
      background-color: $blackPrimary !important;
    }
  }
}

.lighter {
  font-size: 14px;
  font-weight: 500;
  color: $blackUltralight;
}

::v-deep {
  .list .list-item {
    height: 34px;
    margin: 0 0 8px;
    padding: 9px 5px 9px 12px;
    border-radius: 10px;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
    border: solid 1px $greyBorder;
    background-color: $white;
  }
}
</style>
